(function () {
        'use strict';

        angular
            .module('app.core', [
                    'oc.lazyLoad',
                    'ngAnimate', 'ngSanitize', 'ngResource', /*Angular*/
                    'pascalprecht.translate',/*Translation*/
                    'reCAPTCHA',
                    'ngAutodisable',
                    'uiGmapgoogle-maps',/*Map*/
                    'mgo-angular-wizard', /*wizard*/

                    'btford.socket-io',

                    'formly',
                    'formlyBootstrap',

                    'angulartics', 'angulartics.google.analytics','angulartics.piwik',

                    'validator',
                    'builder', 'builder.components',

                    'bootstrapLightbox',
                    'angular-loading-bar',

                    'ui.router', 'ui.calendar', 'ngplus', 'ui.bootstrap', 'ui.scrollfix', /*UI boostrap*/
                    'blocks.exception', 'blocks.logger', 'blocks.router', 'blocks.storage', 'blocks.modal' /*obt  Bocks*/
            ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/core.module.js
 ** module id = 101
 ** module chunks = 0
 **/